import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=5ee241ae&scoped=true&"
import script from "./Bienvenida.vue?vue&type=script&lang=js&"
export * from "./Bienvenida.vue?vue&type=script&lang=js&"
import style0 from "./Bienvenida.vue?vue&type=style&index=0&id=5ee241ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee241ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCardActions,VCol,VContainer,VContent,VImg,VRow})
